import Reflux from 'reflux';
import UserActions from 'flux/actions/UserActions';
import EventData from 'shared/data/Event';
import TeamData from 'shared/data/Team';

let userId = null;

UserActions.loadFromSession.completed.listen((user) => (userId = user._id));

const async = { asyncResult: true },
  EventFormActions = Reflux.createActions({
    updateField: {},
    updateOwner: {},
    updateLabels: {},
    updateLabelsPersistent: async,
    updateOwnerPersistent: async,
    confirmPurchase: {},
    cancelPurchase: {},
    updateTeamIdField: {},
    submit: {},
    createFromProduct: async,
    create: async,
    save: async,
    populate: async,
    populateForEditing: async,
  });

// eslint-disable-next-line no-unused-vars
EventFormActions.populateForEditing.listenAndPromise((teamId, event) => {
  return TeamData.getRoles(teamId);
});

EventFormActions.populate.listenAndPromise(() => {
  return Promise.all([
    EventData.getProducts(),
    TeamData.getByUserId(userId),
  ]).then((resps) => {
    return { eventProducts: resps[0], userTeams: resps[1] };
  });
});

EventFormActions.create.listenAndPromise(EventData.create);
EventFormActions.createFromProduct.listenAndPromise(
  EventData.createFromProduct,
);
EventFormActions.save.listenAndPromise(EventData.update);
EventFormActions.updateOwnerPersistent.listenAndPromise(EventData.updateOwner);
EventFormActions.updateLabelsPersistent.listenAndPromise(
  EventData.updateLabels,
);

export default EventFormActions;
